<template>
    <UBadge :color="meta.color" :label="meta.label" variant="subtle" />
</template>

<script setup lang="ts">
import { INTERVENTION_STATUS_META, type InterventionStatus } from '~/types/fieldPost'

const props = defineProps<{
    status: InterventionStatus
}>()

const meta = computed(() => INTERVENTION_STATUS_META[props.status])
</script>
